import React, { useState } from "react";
import RequestTableItem from "./TableItem";
import RequestTableItemMobile from "./TableItemMobile";
import { isMobile } from "helpers/Mobile";

import styles from "./MainApp.organisms.Dashboard.Table.module.scss";
const RequestOrderTable = ({
  orders,
  headers,
  headerClickOrder,
  handleClickOrder,
}) => {
  const [selectAll, setSelectAll] = useState(false);
  const [selected, setSelected] = useState(null);

  const handleSelectOne = (selectedNew) => {
    if (selected === selectedNew) {
      setSelected(null);
    }
    setSelectAll(false);
  };

  // let isMobile = true
  const table = (
    <div className={styles["dashboard-table"]} data-automation-id="dashboard-table">
      <div className={styles["dashboard-table-header"]}>
        {Object.keys(headers).map((headerKey, index) => {
          let header = headers[headerKey];
          return (
            <div
              key={header.name}
              data-automation-id={`sort-by-${header.name}`}
              onClick={() => {
                headerClickOrder(header.name);
              }}
              data-filter-name={header.name}
              className={`${styles["dashboard-table-header-item"]} ${styles[`table-header-${header.name}`]}`}
            >
              {header.title}{" "}
              <span
                className={`${styles["dashboard-table-header-icon-span"]} ${
                  header.active ? styles["active"] : ""
                }  ${header.direction ? "" : styles["down"]}`}
              >
                {" "}
                <i className={"icon-iconos_flecha-ordenar"}></i>
              </span>
            </div>
          );
        })}
        <div className={styles["table-header-action"]}></div>
      </div>
      <div className={styles["dashboard-table-content"]}>
        {orders.map((requestOrder) => {
          return (
            <div className={styles["dashboard-table-content-item"]} key={requestOrder.id}>
              <RequestTableItem
                requestOrder={requestOrder}
                isSelected={selected === requestOrder.id || selectAll}
                handleSelect={handleSelectOne}
                handleClick={handleClickOrder}
              />
            </div>
          );
        })}
      </div>
    </div>
  );

  const tableMobile = (
    <div
      className={styles["dashboard-table-mobile"]}
      data-automation-id="product-dashboard-table"
    >
      <div className={styles["dashboard-table-content"]}>
        {orders.map((requestOrder) => {
          return (
            <div className={styles["dashboard-table-content-item"]} key={requestOrder.id}>
              <RequestTableItemMobile
                requestOrder={requestOrder}
                isSelected={selected === requestOrder.id || selectAll}
                handleSelect={handleSelectOne}
                handleClick={handleClickOrder}
              />
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className={styles["dashboard-table-container"]}>
      {isMobile ? tableMobile : table}
    </div>
  );
};

export default RequestOrderTable;
